module.exports = __webpack_public_path__ + "img/dashboard-bai.f6970ffc.svg";